export default "__VITE_ASSET__deb58728__"